module.exports = "https://cdn.realtymogul.com/static/media/down_expand_blue2.96a9307f.svg";